<template>
  <div class="boot-loader">
    <div class="boot-loader-content">
      <div role="status" :aria-label="$t('GLOBAL.LOADING_TEXT')">
        <img src="/dubrink-loader.svg" alt="" width="200" />
      </div>
      <div v-if="showRecovery && externalRedirect" class="boot-recovery" role="status">
        <p>{{ $t("GLOBAL.REDIRECT_DELAYED") }}</p>
        <a :href="externalRedirect.url">{{ $t("GLOBAL.REDIRECT_CONTINUE_BTN") }}</a>
        <button type="button" @click="retry">{{ $t("GLOBAL.REDIRECT_RETRY_BTN") }}</button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, watch } from "vue";
import { useTimeoutFn } from "@vueuse/core";
import { externalRedirect, redirectExternally } from "@/helpers/externalRedirect.js";

const showRecovery = ref(false);
const { start, stop } = useTimeoutFn(() => (showRecovery.value = true), 10000, { immediate: false });

watch(
  externalRedirect,
  (redirect) => {
    stop();
    showRecovery.value = false;
    if (redirect) start();
  },
  { immediate: true },
);

const retry = () => {
  redirectExternally(externalRedirect.value.url);
};
</script>
